module.exports = __webpack_public_path__ + "imgs/leafwell3.ce78427422f2465e1fccb9839633c1d7.svg";